import { emptyError } from "../../../Types/ServicesType/servicesType";
import api from "@services/apiList";
import instance from "@services/services";
const {reportsApi}=api
export const userWiseReportSearchService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.userwiseReportSearch,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const userWiseReportSearchpdfService= async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.userwiseReportSearchpdf,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}
